module.exports = __webpack_public_path__ + "static/media/LunellaApartmentINTLRStage01A0024_bg_clean_v001.fc44c2db.webp";